import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

import { DeleteBudgetItems } from "../../../Redux/Reducers/ReportStage/BudgetItems";
import { useEffect, useState } from "react";
import AddEditBudgetItem from "../BudgetItem/AddEditBudgetItem";
import BudgetItemsForStageForm from "./BudgetItemsForStageForm";
const BudgetItemsForStage = (props) => {
  const editBudgetItemForStage = useSelector(
    (state) => state.BudgetItemsForStage.UpdateBudgetItemsForStage
  );
  const [jsonData, setJsonData] = useState({});
  const [newAdded, setnewAdded] = useState(false);

  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [budgetItemsId, setbudgetItemsId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "itemTypeName",
      ShowStatus: true,
      NmaeColumn: "نوع البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemName",
      ShowStatus: true,
      NmaeColumn: "اسم البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemDescription",
      ShowStatus: true,
      NmaeColumn: "وصف البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "numberOfUnits",
      ShowStatus: true,
      NmaeColumn: "عدد الوحدات",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: false,
    },
    {
      KeyName: "unitPrice",
      ShowStatus: true,
      NmaeColumn: "سعر الوحدة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: false,
    },
    {
      KeyName: "newAddedAttachmentFake",
      ShowStatus: true,
      NmaeColumn: "مرفق التعديل الميزاني للبند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,

      FileCostume: true,
      typeColumn: "file",
    },
    {
      KeyName: "actualSpendName",
      ShowStatus: true,
      NmaeColumn: "سعر الصرف الفعلي",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },

 {
      KeyName: "total",
      ShowStatus: true,
      NmaeColumn: "الإجمالي ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "remainderBudget",
      ShowStatus: true,
      NmaeColumn: "المتبقي من ميزانية البند",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma: true,
    },
    {
      KeyName: "supportingDocumentsAttachmentName",
      ShowStatus: true,
      NmaeColumn: "مرفق معززات الصرف",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      notnewAdded: true,
      comma: false,
      FileCostume: true,

      typeColumn: "file",
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        var objects = JSON.parse(e.target.value);
        setnewAdded(objects.newAdded);

        setbudgetItemsId(objects.budgetItemsForStageId);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: props.iconsEditOrView,
      ShowHideByCanEdit: false,
      ShowHideByUser: true,
      caneEditValue: true,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {<BudgetItemsForStageForm canEdit="add" reportId={props.reportId} />}
      </div>
    ),
    title: "بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <BudgetItemsForStageForm
          newAdded={newAdded}
          disabled={props.disabled}
          reportId={props.reportId}
          budgetItemsForStageId={budgetItemsId}
          canEdit="edit"
        />
      </div>
    ),
    title: "بنود الموازنة المطلوبة من مؤسسة عبد الحميد شومان ",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [editBudgetItemForStage]);
  console.log(props.disabled, "ssssssdwdwdwd");

  return (
    <>
      {true ? (
        <>
          <TableAHSF
            culomEdite={culomEdite}
            AllValueAction={true}
            RequestsManagerValue={true}
            uniqueValue={"budgetItemsForStageId"}
            valueButtonAction={"budgetItemsForStageId"}
            URL={`api/BudgetItemsForStage/GetListBudgetItemsForStage`}
            UrlBody={{
              reportStageId: props.reportStageId,
            }}
            staticKeyEdite={staticKeyEdite}
            accessor={RequestAccessor}
            titelTable={" "}
            selectRowNumber={true}
            checkBoksColumName="اختيار"
            sort={true}
            pagination={true}
            AppStatus={true}
            // tableBtn={!shouldDisableFields}
            fileStoreName="SupportingDocumentsAttachment"
            tableBtn={false}
            sortTable={true}
            keyNameSort={"dateCreate"}
            dateKey="dateCreate"
            dateformat="DD/MM/YYYY h:mm a"
            arrayNameSort={["applicationNumber"]}
            search={true}
            openPopupState={false}
            DropdownArrayFiltration={[]}
            DropdownFiltration={false}
            uniqeKeyName={"budgetItemsForStageId"}
            exportData={true}
            checkBoks={props.checkBoks}
            uniqeKeyNameRedux={"budgetItemsForStage"}
            nameColumAction=""
            total={false}
            arrayButton={
              !props.checkBoks && props.disabled ? [] : M_ApplicationsBtns
            }
            // arrayButton={props.checkBoks ? M_ApplicationsBtns : false}
            ArrayNameDataColum={[]}
            columnKeyNameArray={[
              { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
            ]}
            PopupOPjectData={PopupOPjectData}
            popUpTitle={"معلومات الطلب"}
            popUpBody={
              <PopupAHSF
                isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
                isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
                title={popUpBodyOPjectData.title}
                componentBody={popUpBodyOPjectData.componentBody}
                maxWidth={popUpBodyOPjectData.maxWidth}
                maxHeight={popUpBodyOPjectData.maxHeight}
              />
            }
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default BudgetItemsForStage;
